/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, CircularProgress, Divider, Grid, LinearProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { LayoutBase } from '../../layouts';
import { ForwardedMapRender, MarkerPoint, ToolsDashbord } from '../../components/custom';
import { useParams } from 'react-router-dom';
import { DamsServices } from '../../services/api/dams/DamServices';
import { useEffect, useRef, useState } from 'react';
import { formatDateWhitoutHour } from '../../services/helpers/helpers';
import { ReadingServices } from '../../services/api/reading/ReadingServices';
import { CartesianGrid, Cell, Legend, Line, LineChart, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { AnomalyService } from '../../services/api/anomaly/AnomalyService';
import { PlanosDeAcaoService } from '../../services/api/planosDeAcao/PlanosDeAcaoService';
import { opcoesNPA } from '../../components/custom/Anomaly/FormAnomalia';
import { format } from 'date-fns';
import { ActionPlanActivitiesService } from '../../services/api/planosDeAcao/ActionPlanActivitiesService';
import { UserServices } from '../../services/api/users/UserServices';



async function getAtividadesPlano(uuid_plano: string) {
	const r = await ActionPlanActivitiesService.getAll(uuid_plano);
	if (r instanceof Error) { console.log(r.message); }
	return r;
}

async function getUsuarios(uuid_responsavel: string) {
	console.log('uuid_responsavel', uuid_responsavel);
	const r = await UserServices.getById(uuid_responsavel);
	if (r instanceof Error) { console.log(r.message); }
	return r;
}


type CardGraficoProps = {
	title: string;
	children: React.ReactNode;
	loading?: boolean;
}

export function CardGrafico({ title, children, loading }: CardGraficoProps) {
	return (
		<Box
			sx={{
				border: 1,
				borderColor: 'black',
				borderRadius: 2,
				padding: 1,
				height: '25rem',
				alignContent: 'center',
				display: 'flex',
				flexDirection: 'column'
			}}
		>
			<Typography>{title}</Typography>
			<Divider />
			<Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				{loading ? <CircularProgress /> : children}
			</Box>
		</Box>
	);
}

type GraficoAtividadesProps = {
	atividades: any[];
}

export function GraficoStatus_Atividades({ atividades }: GraficoAtividadesProps) {

	const finalizados = atividades.filter((a: any) => a.finalizado === true).length;
	const pendentes = atividades.filter((a: any) => a.finalizado === false).length;

	const loading = !Array.isArray(atividades);

	const data = [
		{ name: 'Finalizadas', value: finalizados, fill: '#4caf50' },
		{ name: 'Não finalizadas', value: pendentes, fill: '#f44336' }
	];

	const semDados = !loading && atividades.length === 0;

	return (
		<CardGrafico title='Atividades dos planos de ação' loading={loading}>
			{loading ? (
				<Box
					sx={{
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<CircularProgress />
				</Box>
			) : semDados ? (
				<Box
					sx={{
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<Typography color="text.secondary">
						Sem dados para exibir
					</Typography>
				</Box>
			) : (
				<ResponsiveContainer width="100%" height="100%">
					<PieChart>
						<Pie
							data={data}
							dataKey="value"
							nameKey="name"
							outerRadius={80}
							label
						>
							{data.map((entry, index) => (
								<Cell key={`cell-${index}`} fill={entry.fill} />
							))}
						</Pie>
						<Tooltip />
						<Legend layout="horizontal" verticalAlign="bottom" align="center" />
					</PieChart>
				</ResponsiveContainer>
			)}
		</CardGrafico>
	);
}

type GraficoStatus_PlanoAcaoProps = {
	planos: any[];
}

export function GraficoStatus_PlanosAcao({ planos }: GraficoStatus_PlanoAcaoProps) {

const nao_inciados = planos.filter((a: any) => a.status === 'NAO INICIADO').length;
	// const concluidos = planos.filter((a: any) => a.status === 'CONCLUIDO').length;
	const em_andamento = planos.filter((a: any) => a.status === 'EM ANDAMENTO').length;
	const finalizados = planos.filter((a: any) => a.status === 'FINALIZADO').length;

	const loading = !Array.isArray(planos);

	const data = [
		{ name: 'Não iniciado', value: nao_inciados, fill: '#02afff' },
		{ name: 'Em andamento', value: em_andamento, fill: '#7d8327' },
		// { name: 'Concluído', value: concluidos, fill: '#4caf50' },
		{ name: 'Finalizado', value: finalizados, fill: '#4caf50' }
	];

	const semDados = !loading && planos.length === 0;

	return (
		<CardGrafico title='Planos de ação' loading={loading}>
			{loading ? (
				<Box
					sx={{
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<CircularProgress />
				</Box>
			) : semDados ? (
				<Box
					sx={{
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<Typography color="text.secondary">
						Sem dados para exibir
					</Typography>
				</Box>
			) : (
				<ResponsiveContainer width="100%" height="100%">
					<PieChart>
						<Pie
							data={data}
							dataKey="value"
							nameKey="name"
							outerRadius={80}
							label
						>
							{data.map((entry, index) => (
								<Cell key={`cell-${index}`} fill={entry.fill} />
							))}
						</Pie>
						<Tooltip />
						<Legend layout="horizontal" verticalAlign="bottom" align="center" />
					</PieChart>
				</ResponsiveContainer>
			)}
		</CardGrafico>
	);
}

type GraficoNivelPerigoPlanoAcaoProps = {
	planos: any[];
}

const NIVEL_PERIGO_PLANO_ACAO_CORES: Record<string, string> = {
	Normal: '#4caf50',
	Atenção: '#ffc107',
	Alerta: '#ff9800',
	Emergência: '#f44336',
};

function getNpaLabelFromValue(npaValue: string): string {
	const npa = opcoesNPA.find(opcao => opcao.value === npaValue);
	if (npa) return npa.label;
	return npaValue || 'Desconhecido';
}

// Planos antigos podem trazer apenas o booleano `finalizado`, sem o status preenchido.
function isPlanoFinalizado(plano: any): boolean {
	return plano?.status === 'FINALIZADO' || plano?.finalizado === true;
}

export function GraficoStatus_NivelPerigoPlanoAcao({ planos }: GraficoNivelPerigoPlanoAcaoProps) {

	const loading = !Array.isArray(planos);

	// A contagem por NPA considera somente os planos em aberto.
	const planosNaoFinalizados: any[] = loading ? [] : planos.filter(plano => !isPlanoFinalizado(plano));

	const contagemPorNivel = planosNaoFinalizados.reduce<Record<string, number>>((acc, plano) => {
		const label = getNpaLabelFromValue(plano.npa);
		acc[label] = (acc[label] || 0) + 1;
		return acc;
	}, {});

	const data = Object.entries(contagemPorNivel).map(([name, value]) => ({ name, value }));

	const semDados = !loading && data.length === 0;

	return (
		<CardGrafico title='NPA - Anomalias' loading={loading}>
			{loading ? (
				<Box
					sx={{
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<CircularProgress />
				</Box>
			) : semDados ? (
				<Box
					sx={{
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<Typography color="text.secondary">
						Sem dados para exibir
					</Typography>
				</Box>
			) : (
				<ResponsiveContainer width="100%" height="100%">
					<PieChart>
						<Pie
							data={data}
							dataKey="value"
							nameKey="name"
							outerRadius={80}
							label
						>
							{data.map((entry, index) => (
								<Cell key={`cell-${index}`} fill={NIVEL_PERIGO_PLANO_ACAO_CORES[entry.name] || '#9e9e9e'} />
							))}
						</Pie>
						<Tooltip />
						<Legend layout="horizontal" verticalAlign="bottom" align="center" />
					</PieChart>
				</ResponsiveContainer>
			)}
		</CardGrafico>
	);
}

type GraficoSetorAtividadesProps = {
	usuarios: any[];
}

export function GraficoSetorAtividades({ usuarios }: GraficoSetorAtividadesProps) {
	const loading = !Array.isArray(usuarios);

	const cores = [
		'#4caf50',
		'#f44336',
		'#2196f3',
		'#ff9800',
		'#9c27b0',
		'#00bcd4',
		'#8bc34a',
		'#795548',
		'#e91e63',
		'#607d8b'
	];

	const setoresAgrupados = usuarios.reduce((acc: Record<string, number>, user: any) => {
		const setor = user.sector || 'Sem setor';

		acc[setor] = (acc[setor] || 0) + 1;
		return acc;
	}, {});

	const data = Object.entries(setoresAgrupados).map(([name, value], index) => ({
		name,
		value,
		fill: cores[index % cores.length]
	}));

	const semDados = !loading && data.length === 0;

	return (
		<CardGrafico title="Alocação de setor por atividades">
			{loading ? (
				<Box
					sx={{
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<CircularProgress />
				</Box>
			) : semDados ? (
				<Box
					sx={{
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<Typography color="text.secondary">
						Sem dados para exibir
					</Typography>
				</Box>
			) : (
				<ResponsiveContainer width="100%" height="100%">
					<PieChart>
						<Pie
							data={data}
							dataKey="value"
							nameKey="name"
							outerRadius={80}
							label
						>
							{data.map((entry, index) => (
								<Cell key={`cell-${index}`} fill={entry.fill} />
							))}
						</Pie>
						<Tooltip />
						<Legend layout="horizontal" verticalAlign="bottom" align="center" />
					</PieChart>
				</ResponsiveContainer>
			)}
		</CardGrafico>
	);
}

export default function DashUnica() {

	const { id } = useParams();
	const [data, setData] = useState<any | null>(null);
	const [leituras, setLeituras] = useState<any | null>(null);
	const [markerPoints, setMarkerPoints] = useState<MarkerPoint[]>([]);
	const mapRef = useRef<HTMLDivElement>(null);
	const [regua, setRegua] = useState<any[]>([]);

	const [pizza, setPizza] = useState<any[]>([]);
	const [anomalias, setAnomalias] = useState<any>();
	const [planosDeAcao, setPlanosDeAcao] = useState<any[]>([]);
	const [atividadesPlanos, setAtividadesPlanos] = useState<any[]>([]);
	const [usuarios, setUsuarios] = useState<any[]>([]);

	async function fetchData(uuid: string) {
		const response = await DamsServices.getById(uuid);
		if (response instanceof Error) {
			console.log('Error', response.message);
		} else {
			setData(response);
			if (response.instrumentos !== undefined) {
				const newMarkerPoints = setMarkers(response.instrumentos);
				setMarkerPoints(newMarkerPoints);
			}
		}
	}

	// async function fetchAtividadesPlano(planos: any[]) {
	// 	const responses = await Promise.all(
	// 		planos.map((p) => getAtividadesPlano(p.uuid))
	// 	);

	// 	const todasAtividades = responses
	// 		.filter((atividades) => Array.isArray(atividades))
	// 		.flat();

	// 	setAtividadesPlanos(todasAtividades);
	// }

	async function fetchDatadoUser(atividades: any[]) {
		console.log('atividades', atividades);

		const response = await Promise.all(
			atividades.map((a) => getUsuarios(a.responsavel_procedimento))
		);

		const allUsers = response.filter((user) => !(user instanceof Error) && user);

		setUsuarios(allUsers);
	}

	async function fetchDataPlano(uuid_barragem: string) {
		const r = await PlanosDeAcaoService.listPlanos(uuid_barragem);
		if (r instanceof Error) { console.log(r.message); } else {
			const filterArray = r.map((item) => ({
				...item,
				codigo_anomalia: !item.codigo_anomalia ? '----' : item.codigo_anomalia
			}));
			setPlanosDeAcao(filterArray);
		}
	}

	async function fetchAtividades(uuid_barragem: string) {
		const r = await ActionPlanActivitiesService.listPerDam(uuid_barragem);
		if (r instanceof Error) { console.log(r.message); } else {
			setAtividadesPlanos(r);
		}
	}

	useEffect(() => {
		if (atividadesPlanos.length > 0) {
			fetchDatadoUser(atividadesPlanos);
		}
	}, [atividadesPlanos]);

	// async function getPlanosDeAcao(anomaliasData: any) {
	// 	if (!anomaliasData || anomaliasData.length === 0) {
	// 		setPlanosDeAcao([]);
	// 		return;
	// 	}

	// 	const uuidsPlanosDeAcao: string[] = [];

	// 	anomaliasData.forEach((anomalia: any) => {
	// 		if (anomalia.detalhes && anomalia.detalhes.length > 0) {
	// 			anomalia.detalhes.forEach((detalhe: any) => {
	// 				if (detalhe.plano_acao && detalhe.plano_acao.length > 0) {
	// 					detalhe.plano_acao.forEach((plano: any) => {
	// 						if (plano.uuid) {
	// 							uuidsPlanosDeAcao.push(plano.uuid);
	// 						}
	// 					});
	// 				}
	// 			});
	// 		}
	// 	});

	// 	if (uuidsPlanosDeAcao.length === 0) {
	// 		setPlanosDeAcao([]);
	// 		return;
	// 	}

	// 	try {
	// 		const promises = uuidsPlanosDeAcao.map(uuid => PlanosDeAcaoService.getById(uuid));
	// 		const responses = await Promise.all(promises);

	// 		const planosValidos = responses.filter(response => !(response instanceof Error));
	// 		setPlanosDeAcao(planosValidos);
	// 		await fetchAtividadesPlano(planosValidos);
	// 	} catch (error) {
	// 		console.error('Erro ao buscar planos de ação:', error);
	// 		setPlanosDeAcao([]);
	// 	}
	// }

	function normalizaCota(cota: string | number | undefined) {
		if (!cota) return null;
		return typeof cota === 'number' ? cota : parseFloat(cota.replace(',', '.'));
	}

	async function getLeituras(uuid: string) {
		const response = await ReadingServices.getAll(uuid);

		if (response instanceof Error) {
			console.log('Erro', response.message);
			return;
		}

		if (!Array.isArray(response)) {
			console.error('Resposta inválida, esperado um array', response);
			return;
		}

		setLeituras(response);
		getDadosPizzaAlerta(response);

		const instrumentosRegua = response.filter(
			(instrumento: any) => instrumento?.tipo_instrumento === 'regua'
		);

		const mapaPorData = new Map<string, any>();

		instrumentosRegua.forEach((instrumento: any) => {
			const nome = instrumento.nome;

			instrumento.leituras?.forEach((leitura: any) => {
				const data = format(new Date(leitura.data_leitura), 'dd/MM/yyyy');
				const cota = normalizaCota(leitura.cota);

				if (!mapaPorData.has(data)) {
					mapaPorData.set(data, { data });
				}

				const entrada = mapaPorData.get(data);
				entrada[nome] = cota;
			});
		});

		const dadosGrafico = Array.from(mapaPorData.values()).sort(
			(a, b) =>
				new Date(a.data).getTime() - new Date(b.data).getTime()
		);

		setRegua(dadosGrafico);
	}


	const nomesInstrumentos = Array.isArray(regua)
		? Array.from(
			new Set(
				regua.flatMap(obj => Object.keys(obj).filter(key => key !== 'data'))
			)
		)
		: [];

	useEffect(() => {
		async function initData() {
			if (!id) return;

			await fetchData(id);
			await getLeituras(id);
			await fetchDataPlano(id);
			await fetchAtividades(id);
			// await getInstrumentos(id);

			const anomaliasResponse = await AnomalyService.list(id);
			if (!(anomaliasResponse instanceof Error)) {
				setAnomalias(anomaliasResponse);
			} else {
				console.log('Error', anomaliasResponse.message);
			}
		}

		initData();
	}, [id]);

	function setMarkers(instrumentos: any[]): MarkerPoint[] {
		return instrumentos.map((instrumento, index) => {
			const uuid: string = instrumento.uuid;
			const position: [number, number] = [instrumento.latitude, instrumento.longitude];
			const title: string = instrumento.nome;
			const type: string = instrumento.tipo_instrumento;
			const ew: string = instrumento.utm_ew;
			const ns: string = instrumento.utm_ns;
			const elev: number = instrumento.elevacao ?? 'Não informado';
			const update: string = formatDateWhitoutHour(instrumento.update_date);
			const icone: string = instrumento.icone;
			const route = `instrument/${index}`;
			const showMarker = true;
			const faixa_verde: string = instrumento.limite_faixa_verde;
			const faixa_amarela: string = instrumento.limite_faixa_amarela;
			const faixa_laranja: string = instrumento.limite_faixa_laranja;
			const faixa_vermelha: string = instrumento.limite_faixa_vermelha;
			const nivel_alerta: string = instrumento.nivel_alerta;
			return { uuid, position, title, type, ew, ns, elev, route, update, showMarker, icone, faixa_verde, faixa_amarela, faixa_laranja, faixa_vermelha, nivel_alerta };
		});
	}

	function getIdadae(fundacao: string | null): string {
		if (!fundacao || isNaN(Number(fundacao))) {
			return '---';
		}

		const anofundacao = parseInt(fundacao);
		const anoAtual = new Date().getFullYear();
		const idade = anoAtual - anofundacao;
		return idade.toString();
	}

	function getDadosPizzaAlerta(leituras: any) {
		const leituras_filtradas = leituras.filter((l: { nivel_alerta: string; }) => l.nivel_alerta?.trim() !== 'Não há limite de referência estabelecido');
		if (!Array.isArray(leituras_filtradas)) return [];

		const leiturasSemUltimo = leituras_filtradas.slice(0, -1);

		const ultimosNiveis = leiturasSemUltimo.flatMap((instrumento) => {
			if (!Array.isArray(instrumento?.leituras) || instrumento.leituras.length === 0) {
				return [];
			}

			const ultimaLeitura = instrumento.leituras.reduce(
				(maisRecente: any, atual: any) => {
					const dataMaisRecente = new Date(maisRecente.data_leitura);
					const dataAtual = new Date(atual.data_leitura);
					return dataAtual > dataMaisRecente ? atual : maisRecente;
				}
			);

			if (ultimaLeitura?.nivel_alerta?.trim() === 'Não há limite de referência estabelecido') {
				return [];
			}

			return [ultimaLeitura?.nivel_alerta ?? 'Desconhecido'];
		});


		const contagemPorNivel = ultimosNiveis.reduce<Record<string, number>>((acc, nivel) => {
			acc[nivel] = (acc[nivel] || 0) + 1;
			return acc;
		}, {});

		setPizza(
			Object.entries(contagemPorNivel).map(([name, value]) => ({
				name,
				value,
			}))
		);
	}


	const cores: Record<string, string> = {
		Normal: '#4caf50',
		Alerta: '#ff9800',
		Atenção: '#ffc107',
		Emergência: '#f44336',
		Desconhecido: '#9e9e9e'
	};

	function getNpaLabel(npaValue: string): string {
		const npa = opcoesNPA.find(opcao => opcao.value === npaValue);
		return npa ? npa.label : npaValue;
	}

	function getCorStatus(finalizado: boolean) {
		return finalizado ? 'success.main' : 'error.main';
	}

	return (
		<LayoutBase
			title='Dashboard Única'
			tollBar={
				<ToolsDashbord />
			}
		>
			<Box>
				{data == null ? (
					<LinearProgress />
				) :
					(
						<Grid container spacing={2} padding={2}>
							<Grid item xs={12}>
								<Typography variant='h4'>{data.nome}</Typography>
								<Divider />
							</Grid>
							<Grid item xs={data.image === null ? 12 : 5} >
								<Box sx={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									// border: 1,
									borderColor: 'white',
									height: '25rem',
									// margin: 2,
									borderRadius: 4,
									overflow: 'hidden'
								}}>
									<ForwardedMapRender
										center={[data?.latitude && Number(data.latitude), data?.longitude && Number(data.longitude)]}
										markerPoints={markerPoints}
										show={false}
										type='map'
										ref={mapRef}
										isLocation={false}
										damName={data?.nome}
										lat={data.latitude}
										lon={data.longitude}
									/>
								</Box>
							</Grid>
							{data.image && data.image !== null &&
								<Grid item xs={7}>
									<Box
										sx={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											// border: 1,
											borderColor: 'white',
											height: '25rem',
											// margin: 2,
											borderRadius: 4,
											overflow: 'hidden'
										}}
									>
										<img
											src={`data:image/png;base64,${data.image}`}
											alt="img"
											style={{
												width: '100%',
												height: '100%',
												objectFit: 'cover'
											}}
										/>
									</Box>
								</Grid>
							}
							<Grid item xs={2}>
								<Box sx={{
									border: 1,
									borderColor: 'black',
									borderRadius: 2,
									padding: 1,
									textAlign: 'center',
									height: '10rem',
									bgcolor: `${cores[data.npgb as string]}66`,
									alignContent: 'center',
								}}>
									<Typography fontSize='1rem' >Nível de </Typography>
									<Typography fontSize='1rem'>Perigo Global</Typography>
									<Divider />
									<Typography fontSize='1.6rem' fontWeight='bold' alignSelf={'center'}>{data.npgb ?? '---'}</Typography>
								</Box>
							</Grid>
							<Grid item xs={2}>
								<Box sx={{
									border: 1,
									borderColor: 'black',
									borderRadius: 2,
									padding: 1,
									textAlign: 'center',
									height: '10rem',
									alignContent: 'center',
								}}>
									<Typography fontSize='1rem'>Total de</Typography>
									<Typography fontSize='1rem'>Instrumentos</Typography>
									<Divider />
									<Typography fontSize='1.6rem' fontWeight='bold' alignSelf={'center'}>{data.instrumentos.length}</Typography>
								</Box>
							</Grid>
							<Grid item xs={8}>
								<Box sx={{
									border: 1,
									borderColor: 'black',
									borderRadius: 2,
									padding: 1,
									textAlign: 'center',
									maxHeight: '10rem',
									height: '10rem'
								}}>
									<Table>
										<TableHead>
											<TableRow>
												<TableCell>Tipo</TableCell>
												<TableCell>Idade</TableCell>
												<TableCell>Volume(m³)</TableCell>
												<TableCell>Altura</TableCell>
												{/* <TableCell>DPA</TableCell> */}
											</TableRow>
										</TableHead>
										<TableBody>
											<TableRow>
												<TableCell>{data.composicao_macico ?? '---'}</TableCell>
												<TableCell>{getIdadae(data.inicio_operacao) ?? '---'}</TableCell>
												<TableCell>{data.volume_estrutura ?? '---'}</TableCell>
												<TableCell>{data.altura_maxima_crista ?? '---'}</TableCell>
												{/* <TableCell>{'Aguardando'}</TableCell> */}
											</TableRow>
										</TableBody>
									</Table>
								</Box>
							</Grid>
							<Grid item xs={12}>
								<Box sx={{ border: 1, borderColor: 'black', borderRadius: 2, padding: 1 }}>
									<Typography>Nível do Reservatório</Typography>
									<Divider />
									<ResponsiveContainer width="100%" height={200} style={{ padding: 1 }}>
										{/* <LineChart data={regua} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
											<CartesianGrid strokeDasharray="3 3" />
											<XAxis dataKey="data" />
											<YAxis
												label={{ value: 'Cota (m)', angle: -90, position: 'insideLeft' }}
												tickFormatter={(value) => parseFloat(value).toFixed(2)}
											/>
											<Tooltip formatter={(value) => `${value} m`} />
											<Line type="monotone" dataKey="cota" stroke="#0c00f3ff" activeDot={{ r: 6 }} />
										</LineChart> */}
										<LineChart
											data={regua}
											margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
										>
											<CartesianGrid strokeDasharray="3 3" />
											{/* <XAxis dataKey="data" /> */}
											<XAxis
												dataKey="data"
												fontFamily='Roboto'
												height={60}
												interval="preserveStartEnd"
												tick={({ x, y, payload }: { x: number; y: number; payload: { value: string } }) => (
													<g transform={`translate(${x},${y})`}>
														<text
															x={0}
															y={0}
															dy={10}
															textAnchor="end"
															fill="#666"
															fontSize={11}
															fontFamily="Roboto"
															transform="rotate(-45)"
														>
															{payload.value}
														</text>
													</g>
												)}
											/>
											{/* <YAxis
												label={{ value: 'Cota (m)', angle: -90, dx: -10, position: 'insideLeft' }}
												tickFormatter={(value) => parseFloat(value).toFixed(2)}
											/> */}
											<YAxis
												label={{ value: 'Cota (m)', angle: -90, dx: -10, position: 'insideLeft' }}
												tickFormatter={(value) => parseFloat(value).toFixed(2)}
												domain={['dataMin - 1', 'dataMax + 1']} // deixa o eixo "apertado" nos dados
											/>
											<Tooltip formatter={(value) => `${value} m`} />
											<Legend />

											{nomesInstrumentos.map((nome, index) => (
												<Line
													key={nome}
													type="monotone"
													dataKey={nome}
													stroke={`hsl(${(index * 60) % 360}, 100%, 40%)`}
													connectNulls
													activeDot={{ r: 5 }}
												/>
											))}
										</LineChart>


									</ResponsiveContainer>
								</Box>
							</Grid>
							{/* <Grid item xs={8}>
								<Box sx={{
									border: 1,
									borderColor: 'black',
									borderRadius: 2,
									padding: 1,
									// maxHeight: '25rem',
									height: '25rem',
									overflowY: 'auto'
								}}>
									<Typography>Carta de Risco</Typography>
									<Divider />
									<Table>
										<TableHead>
											<TableRow>
												<TableCell>Instrumento</TableCell>
												<TableCell>Atenção</TableCell>
												<TableCell>Alerta</TableCell>
												<TableCell>Emergência</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{data.instrumentos
												.slice() // Cria uma cópia para evitar mutar o estado original
												.sort((a: any, b: any) => a.nome.localeCompare(b.nome))
												.map((instrumento: any) => (
													<TableRow key={instrumento.uuid}>
														<TableCell>{instrumento.nome}</TableCell>
														<TableCell>{Number(instrumento.limite_faixa_amarela)?.toFixed(2).replace('.', ',') ?? '---'}</TableCell>
														<TableCell>{Number(instrumento.limite_faixa_laranja)?.toFixed(2).replace('.', ',') ?? '---'}</TableCell>
														<TableCell>{Number(instrumento.limite_faixa_vermelha)?.toFixed(2).replace('.', ',') ?? '---'}</TableCell>
													</TableRow>
												))}
										</TableBody>
									</Table>
								</Box>
							</Grid> */}
							{/* <Grid item xs={3}>
								<Box sx={{
									border: 1,
									borderColor: 'black',
									borderRadius: 2,
									padding: 1,
									maxHeight: '25rem',
									height: '25rem'
								}}>
									<Typography textAlign={'center'}>Frequência de Alerta</Typography>
									<Divider />
									<Typography><strong>Normal:</strong>{data.analise_frequencia_instrumentos.Normal ?? '---'}</Typography>
									<Typography><strong>Atenção:</strong>{data.analise_frequencia_instrumentos.Atenção ?? '---'}</Typography>
									<Typography><strong>Alerta:</strong>{data.analise_frequencia_instrumentos.Alerta ?? '---'}</Typography>
									<Typography><strong>Emergência:</strong>{data.analise_frequencia_instrumentos.Emergência ?? '---'}</Typography>
								</Box>
							</Grid> */}
							<Grid item xs={4}>
								<GraficoStatus_NivelPerigoPlanoAcao planos={planosDeAcao} />
							</Grid>

							<Grid item xs={4}>
								<GraficoStatus_PlanosAcao planos={planosDeAcao} />
							</Grid>
							<Grid item xs={4}>
								<GraficoStatus_Atividades atividades={atividadesPlanos} />
							</Grid>
							<Grid item xs={4}>
								<GraficoSetorAtividades usuarios={usuarios} />
							</Grid>


							<Grid item xs={12}>
								<Box sx={{
									border: 1,
									borderColor: 'black',
									borderRadius: 2,
									padding: 1,
									maxHeight: '30rem',
									overflowY: 'auto'
								}}>
									<Typography variant="h6" component="h2" gutterBottom>Planos de Ação</Typography>
									<Divider sx={{ mb: 2 }} />
									{planosDeAcao.length > 0 ? (
										<Table stickyHeader>
											<TableHead>
												<TableRow>
													<TableCell>Código da Anomalia</TableCell>
													<TableCell>Data de Criação</TableCell>
													<TableCell>Data Limite</TableCell>
													<TableCell>Finalizado?</TableCell>
													<TableCell>NPA</TableCell>
													<TableCell>Equipe Responsável</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{planosDeAcao.map((plano: any) => (
													<TableRow key={plano.uuid}>
														<TableCell>{plano.codigo_anomalia}</TableCell>
														<TableCell>{formatDateWhitoutHour(plano.data_criacao)}</TableCell>
														<TableCell>{formatDateWhitoutHour(plano.data_limite_seguranca)}</TableCell>
														<TableCell sx={{ color: getCorStatus(plano.finalizado), fontWeight: 'bold' }}>
															{plano.finalizado ? 'Sim' : 'Não'}
														</TableCell>
														<TableCell>{getNpaLabel(plano.npa)}</TableCell>
														<TableCell>{plano.responsavel_principal}</TableCell>
													</TableRow>
												))}
											</TableBody>
										</Table>
									) : (
										<Typography variant="body1" align="center" sx={{ mt: 2 }}>
											Nenhum plano de ação encontrado.
										</Typography>
									)}
								</Box>
							</Grid>
						</Grid>
					)}
			</Box>
		</LayoutBase >
	);
}